var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvoryList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05719 2.93693L6.20597 1.78591L7.79529 3.37835L5.86682 5.31225L6.75791 6.20508L9.57747 3.37835L6.20597 0.000257492L4.16611 2.0441L5.05719 2.93693Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1304 6.23766L1.69739 4.51696L0 6.21767L1.72399 7.94336L5.1304 6.23766Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67075 5.14258L3.37155 2.83888L2.60681 3.60678L5.67075 5.14258Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63342 8.85807L3.37156 9.59766L5.59097 7.37558L2.63342 8.85807Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50026 6.21L8.37839 7.08984L9.25652 6.20999L8.37839 5.33015L7.50026 6.21Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9175 9.91157L6.20596 10.6245L5.05387 9.47182L4.16278 10.3646L6.20596 12.4102L7.80859 10.8044L6.9175 9.91157Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86697 7.09905L7.31499 8.54989L8.68653 9.92578L9.57762 9.03295L6.7564 6.20622L5.86697 7.09905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryList);
export default __webpack_public_path__ + "static/media/IvoryList.d59cbf6c8d2f2b8f0c55428a41db8ad5.svg";
export { ForwardRef as ReactComponent };